<!--
    描述：按钮
    日期：2021/04/27
    作者：zwh
-->
<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>按钮列表</b></span>
				</div>
				<div class="btnGroups">
					<el-button type="success"
							   size="small"
							   icon="el-icon-check"
							   v-if="roleBtns.includes('group_role_menu_btn_save') && showBtn"
							   @click="saveClick()">保存</el-button>
				</div>
			</div>

			<div class="w-page-container pdb10">
				<div class="check-all"
					 v-show="showCheckAll">
					<el-checkbox :indeterminate="isIndeterminate"
								 v-model="checkAll"
								 @change="handleCheckAllChange">全选</el-checkbox>
				</div>
				<div class="w-table-layout">
					<div class="w-table-content"
						 ref="content"
						 style=" overflow-y: auto; border:1px solid #eee">
						<el-tree ref="btnTree"
								 :height="tableObj.tableH"
								 :data="tableObj.data"
								 :props="defaultProps"
								 :expand-on-click-node="false"
								 :highlight-current="true"
								 default-expand-all
								 show-checkbox
								 :check-strictly="true"
								 node-key="id"
								 :default-checked-keys="treeDefaultCheckedKey"></el-tree>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { getBtnsByRoleIdMenuId } from 'api/system/menuBtn.js'
import {
	saveOrUpdateRoleMenuBtn,
	getCheckedBtn,
	getLimitBtn,
	getBtns,
	saveOrUpdateBtn,
} from 'api/system/sysGroupRoleMenuBtn.js'

export default {
	name: '',
	props: {
		// 当前是 公共角色 还是 私有角色
		currentRole: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			groupId: '',
			roleId: '',
			roleType: '',
			menuId: '',

			tableObj: {
				loading: false,
				tableH: 400,
				data: [],
			},
			defaultProps: {
				children: 'children',
				label: 'btnName',
			},
			//默认选择信息
			treeDefaultCheckedKey: [],
			// 全部按钮
			menuBtns: [],
			// 全选
			showCheckAll: false,
			checkAll: false,
			isIndeterminate: false,
		}
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.content.offsetHeight
			}, 100)
		})
	},
	// 缓存页面进入时
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.content.offsetHeight
			}, 100)
		})
	},
	computed: {
		...mapState('app', { clientSize: (state) => state.clientSize }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),

		// 是否展示 btn
		showBtn() {
			let a = this.userInfo.roleType === 1
			let b = this.currentRole === '1007002'
			return a || b
		},
	},
	watch: {
		clientSize(val) {
			this.tableObj.tableH = this.$refs.content.offsetHeight
		},
	},
	created() {},
	methods: {
		init(obj) {
			this.treeDefaultCheckedKey = []
			this.tableObj.data = []
			//赋值菜单信息
			this.groupId = obj.groupId
			this.roleId = obj.roleId
			this.roleType = obj.roleType
			this.menuId = obj.menuId

			if (this.groupId == '' || this.roleId == '' || this.menuId == '')
				return

			//查询按钮信息
			this.getMenuBtnTableList()

			/*
            this.limitMenuBtnIdList = []
            //获取菜单按钮列表信息
            this.getLimitMenuBtns().then(val => {
                this.getMenuBtnTableList();
            });
            */

			//获取权限菜单数据
			// this.getCheckedBtn()
		},

		//获取菜单按钮列表信息
		getMenuBtnTableList() {
			let that = this
			let param = {
				roleId: this.roleId,
				menuId: this.menuId,
			}

			getBtns(param).then((res) => {
				if (res.operationCode == 1) {
					let data = res.data.sysBtnList
					this.showCheckAll =
						res.data && res.data.sysBtnList.length > 0
					this.menuBtns = res.data.sysBtnList.map((x) => x.id)
					if (res.data != null) {
						this.treeDefaultCheckedKey =
							res.data.checkBtnIdList.concat()

						let _all = this.menuBtns.some(
							(x) =>
								this.treeDefaultCheckedKey.findIndex(
									(y) => y === x
								) === -1
						)
						this.checkAll = _all ? false : true
						this.isIndeterminate =
							res.data.checkBtnIdList.length > 0 && _all
					}
					that.tableObj.data = data
					//获取限定按钮
					this.getLimitBtn()
					
				}
			})
		},

		//获取默认选择按钮
		getCheckedBtn() {
			let that = this
			let param = {
				groupId: this.groupId,
				roleId: that.roleId,
				menuId: that.menuId,
			}
			getCheckedBtn(param).then((res) => {
				if (res.operationCode == 1) {
					//默认选择id list
					this.treeDefaultCheckedKey = res.data
				}
			})
		},

		//获取限定按钮信息
		getLimitBtn() {
			let that = this
			//点击预设角色
			// if (that.roleType == '1007001') {
			// 	let _data = that.tableObj.data.concat()
			// 	//设置按钮不可点击
			// 	_data = _data.map((v) => {
			// 		return { ...v, disabled: true }
			// 	})
			// 	that.tableObj.data = _data.concat()
			// 	return
			// }
			let param = {
				groupId: that.groupId,
				roleId: that.roleId,
				menuId: that.menuId,
			}

			//获取限定按钮信息
			getLimitBtn(param).then((res) => {
				if (res.operationCode == 1) {
					let limitBtnIdList = res.data
					let data = that.tableObj.data.concat()
					data.forEach((v) => {
						//若是范围内按钮信息，则此按钮可点击
						if (limitBtnIdList.includes(v.id)) v.disabled = false
					})
					that.tableObj.data = data.concat()
				}
			})
		},

		//保存
		saveClick() {
			let that = this
			if (that.groupId == '') {
				that.$message({ message: '请选择用户组信息', type: 'warning' })
				return
			}
			if (that.roleId == '') {
				that.$message({ message: '请选择角色信息', type: 'warning' })
				return
			}
			if (that.menuId == '') {
				that.$message({ message: '请选择菜单信息', type: 'warning' })
				return
			}
			//选择的按钮信息
			let idsSelection = this.$refs.btnTree.getCheckedKeys().concat()
			let param = {
				groupId: that.groupId,
				roleId: that.roleId,
				menuId: that.menuId,
				btnIdsSelection: idsSelection,
			}
			saveOrUpdateBtn(param).then((res) => {
				if (res.operationCode == 1) {
					that.$message({ message: '保存成功', type: 'success' })
				}
			})
		},

		// 树节点选择事件
		handleCheck(current, obj) {
			let _checkedAll = this.menuBtns.every(
				(x) => obj.checkedKeys.findIndex((y) => y === x) > -1
			)
			this.checkAll = _checkedAll
			this.isIndeterminate = _checkedAll ? false : true

			if (obj.checkedKeys.length === 0) {
				this.isIndeterminate = false
			}
		},

		// 全选事件
		handleCheckAllChange(val) {
			let arr = this.$utils.clone(this.menuBtns, true)
			this.isIndeterminate = false
			val
				? this.$refs.btnTree.setCheckedKeys(arr, true)
				: this.$refs.btnTree.setCheckedKeys([], true)
		},
	},
}
</script>
<style lang="less">
.w-page-container {
	display: flex;
	flex-direction: column;

	.check-all {
		height: 40px;
		line-height: 40px;
		border: 1px solid #eee;
		border-bottom: none;
		padding: 0 23px;
	}
}
</style>